import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

@Directive({
  selector: '[InfiniteScroll]',
  standalone: true
})
export class InfiniteScrollDirective implements OnInit, OnDestroy {

  @Input() rootMargin: number = 0;
  @Input() set enableEvents(value: boolean) {
    this.hasScrolled = value;
  }
  @Output() scrolled = new EventEmitter<void>();

  public isVisible = false;
  private observer!: IntersectionObserver;
  private hasScrolled = false;

  constructor(private readonly element: ElementRef) {}

  ngOnInit(): void {
    this.createObserver();
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private createObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.isVisible = entry.isIntersecting;
          if (entry.isIntersecting && this.hasScrolled) {
            this.scrolled.emit();
          }
        });
      },
      {
        rootMargin: `0px 0px ${this.rootMargin}px 0px`,
      }
    );

    this.observer.observe(this.element.nativeElement);
  }

}
